import React, { Component } from 'react';
import { Avatar } from 'antd';

class ShowAvatar extends Component {
    handleDisplayAvatar() {
        const {name, img} = this.props

        if (img === null) {
            const tokens = name.split(' ');
            if (tokens.length > 1) {
                return tokens[0]
                    .charAt(0)
                    .toUpperCase() + tokens[1]
                    .charAt(0)
                    .toUpperCase();
            } else if (tokens.length === 1) {
                if (tokens[0].length > 1) {
                    return tokens[0]
                        .substring(0, 2)
                        .toUpperCase();
                }
            }
            return tokens[0].toUpperCase();
        } else {
            return <img src={img} alt=""/>
        }
    }
    render() {
        const {name, img} = this.props
        return (
            <div className="member-image">
                <Avatar shape="square" className={`avatar-customer ${name ? 'value' : ''}`} src={img}>{this.handleDisplayAvatar()}</Avatar>
            </div>
        );
    }
}

export default ShowAvatar;
